import { PageResponse } from '@core/entities/pagination'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { tasksKeys, RequestTypes } from '@core/react-query/features/tasks/tasks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  ITaskPaginated,
  TaskPaginated,
} from '@core/entities/task/TaskPaginated'

const dataTransformer = (response: PageResponse<ITaskPaginated>) => {
  return {
    ...response,
    content: response.content.map((task) => TaskPaginated.new(task)),
  }
}

export const useGetMyTasks = (
  payload: RequestTypes['getMyTasks'],
  options: UseQueryOptions<
    PageResponse<ITaskPaginated>,
    RequestErrorType,
    PageResponse<TaskPaginated>
  > = {},
) => {
  return useQuery({
    select: dataTransformer,
    ...tasksKeys.myTasks(payload),
    keepPreviousData: true,
    ...options,
  })
}
